import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Marketplace from "@/pages/Marketplace";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import RequestCare from "@/pages/RequestCare";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Families from "@/pages/Families";
import Caregivers from "@/pages/Caregivers";
import Businesses from "@/pages/Businesses";
import Government from "@/pages/Government";
import Technology from "@/pages/Technology";
import RequestDemo from "@/pages/RequestDemo";
import Partners from "@/pages/Partners";
import CoursePlayer from "@/pages/CoursePlayer";
import Certificate from "@/pages/Certificate";
import AdminDashboard from "@/pages/AdminDashboard";
import Compliance from "@/pages/Compliance";
import StateProfile from "@/pages/StateProfile";
import CompareStates from "@/pages/CompareStates";
import NationalMap from "@/pages/NationalMap";
import AdminCompliance from "@/pages/AdminCompliance";
import ExpandAgency from "@/pages/ExpandAgency";
import WorkforceReadiness from "@/pages/WorkforceReadiness";
import TrainingMarketplace from "@/pages/TrainingMarketplace";
import Opportunities from "@/pages/Opportunities";
import AdminChanges from "@/pages/AdminChanges";
import CourseSeats from "@/pages/CourseSeats";
import Platform from "@/pages/Platform";
import Investors from "@/pages/Investors";
import ClaimSeat from "@/pages/ClaimSeat";
import CommandCenter from "@/pages/CommandCenter";
import OpsCenter from "@/pages/OpsCenter";
import ApprovalCenter from "@/pages/ApprovalCenter";
import Crm from "@/pages/Crm";
import Recruiting from "@/pages/Recruiting";
import Scheduling from "@/pages/Scheduling";
import LeadMatch from "@/pages/LeadMatch";
import Team from "@/pages/Team";
import ActivityLog from "@/pages/ActivityLog";
import Concierge from "@/pages/Concierge";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import BusinessInquiry from "@/pages/BusinessInquiry";
import Intelligence from "@/pages/Intelligence";
import Enterprise from "@/pages/Enterprise";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/families" element={<Families />} />
              <Route path="/caregivers" element={<Caregivers />} />
              <Route path="/businesses" element={<Businesses />} />
              <Route path="/government" element={<Government />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/request-demo" element={<RequestDemo />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/services" element={<Services />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/store" element={<Store />} />
              <Route path="/store/:id" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-care" element={<RequestCare />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/learn/:courseId" element={<CoursePlayer />} />
              <Route path="/certificate/:courseId" element={<Certificate />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/map" element={<NationalMap />} />
              <Route path="/admin/compliance" element={<AdminCompliance />} />
              <Route path="/admin/changes" element={<AdminChanges />} />
              <Route path="/seats" element={<CourseSeats />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/investors" element={<Investors />} />
              <Route path="/claim-seat" element={<ClaimSeat />} />
              <Route path="/command" element={<CommandCenter />} />
              <Route path="/ops" element={<OpsCenter />} />
              <Route path="/ops/approvals" element={<ApprovalCenter />} />
              <Route path="/ops/crm" element={<Crm />} />
              <Route path="/ops/recruiting" element={<Recruiting />} />
              <Route path="/ops/scheduling" element={<Scheduling />} />
              <Route path="/ops/match/:leadId" element={<LeadMatch />} />
              <Route path="/ops/team" element={<Team />} />
              <Route path="/ops/enterprise" element={<Enterprise />} />
              <Route path="/ops/activity" element={<ActivityLog />} />
              <Route path="/concierge" element={<Concierge />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/billing/success" element={<BillingSuccess />} />
              <Route path="/for-business" element={<BusinessInquiry />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/expand" element={<ExpandAgency />} />
              <Route path="/workforce" element={<WorkforceReadiness />} />
              <Route path="/training" element={<TrainingMarketplace />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/compliance/compare" element={<CompareStates />} />
              <Route path="/compliance/:slug" element={<StateProfile />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
